const CANONICAL_DOMAIN = 's.justmote.me'

export const API_BASE_URL =
  process.env.REACT_APP_BASE_URL || `https://${CANONICAL_DOMAIN}/`
